import { ApolloClient, InMemoryCache, createHttpLink } from '@apollo/client'
import env from '@app/environment'

/**
 * Minimal unauthenticated Apollo Client for public/pre-auth mutations
 * (e.g. sendMagicLink) that run before a user session exists.
 *
 * The full authenticated client lives in index.tsx and is provided
 * to React components via <ApolloProvider>. This client is only used
 * in plain helper functions that cannot call React hooks.
 */
export const publicClient = new ApolloClient({
  link: createHttpLink({ uri: env.API_URL }),
  cache: new InMemoryCache(),
})
